import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import AuthModal from "./AuthModal"; // Import your modal

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [authMode, setAuthMode] = useState("login");

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setAuthLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const showAuthModal = (mode = "login") => {
    setAuthMode(mode);
    setAuthModalOpen(true);
  };

  const hideAuthModal = () => setAuthModalOpen(false);

  return (
    <AuthContext.Provider value={{ user, authLoading, showAuthModal, hideAuthModal }}>
      {children}
      <AuthModal
        isOpen={authModalOpen}
        onClose={hideAuthModal}
        mode={authMode}
        onSwitchMode={setAuthMode}
      />
    </AuthContext.Provider>
  );
};